{
  "title": "Prices and settings",
  "description": "Default prices for operations and the shift close password",
  "salePrices": "Sale prices",
  "purchasePrices": "Purchase prices",
  "quantities": "Quantities",
  "security": "Security",
  "fields": {
    "dieselBarrelSalePrice": "Diesel Barrel Sale Price",
    "dieselJerrycanSalePrice": "Diesel Jerrycan Sale Price",
    "petrolBarrelSalePrice": "Petrol Barrel Sale Price",
    "petrolJerrycanSalePrice": "Petrol Jerrycan Sale Price",
    "dieselBarrelPurchasePrice": "Diesel Barrel Purchase Price",
    "dieselJerrycanPurchasePrice": "Diesel Jerrycan Purchase Price",
    "petrolBarrelPurchasePrice": "Petrol Barrel Purchase Price",
    "petrolJerrycanPurchasePrice": "Petrol Jerrycan Purchase Price",
    "jerrycansInBarrel": "Jerrycans per Barrel",
    "litersInJerrycan": "Liters per Jerrycan"
  },
  "informativeNote": "For information only, not used in calculations",
  "closePassword": {
    "label": "Shift Close Password",
    "placeholder": "Leave empty to keep the current password",
    "setHint": "A password is set",
    "notSetHint": "No password is set"
  },
  "readOnlyNotice": "You don't have permission to edit prices and settings",
  "save": "Save",
  "confirm": {
    "title": "Save changes to prices and settings?",
    "description": "The new prices will apply to upcoming operations immediately.",
    "changedPricesTitle": "Prices that changed:",
    "closePasswordChanged": "The shift close password will be changed.",
    "noChanges": "There are no price changes.",
    "confirmLabel": "Save",
    "overviewPasswordChanged": "The overview password will be changed."
  },
  "discard": {
    "title": "Discard changes?",
    "description": "The changes you made to prices and settings will not be saved.",
    "confirmLabel": "Discard",
    "cancelLabel": "Keep editing"
  },
  "toasts": {
    "saved": "Prices and settings updated successfully"
  },
  "validation": {
    "mustBePositive": "The value must be greater than zero",
    "tooManyDecimals": "At most five decimal places are allowed.",
    "passwordTooShort": "The password must be at least 4 characters"
  },
  "overviewPassword": {
    "label": "Overview Password",
    "placeholder": "Leave empty to keep the current password",
    "setHint": "A password is set",
    "notSetHint": "No password is set"
  },
  "phoneVerification": {
    "label": "Verify the phone number with a WhatsApp code",
    "help": "A code is sent by WhatsApp when a customer is added or a phone is changed",
    "on": "On",
    "off": "Off",
    "helpSave": "the record is saved only after the code is entered"
  }
}
